import { useCallback, useRef, useState } from 'react'
import map from 'lodash/map'
import { readZustandLocalStorage } from '../../../store/localStorageUtils'
import { playerStoreKey, playerStoreKeys } from '../../../store/playerStore/playerStoreConstants'
import { config } from '../../../../components/Init/Init'
import { useSetPlayerActiveCurrencyData, useUpdatePlayerWallets } from '../../../store/playerStore/playerActions'

export const useHandleFirebaseWallets = () => {
  const [gameBalanceReload, setGameBalanceReload] = useState(false)
  const isPlayerActiveCurrencyDataInit = useRef(false)

  const { setPlayerActiveCurrencyData } = useSetPlayerActiveCurrencyData()
  const { updatePlayerWallets } = useUpdatePlayerWallets()

  const handleFirebaseWallets = useCallback(
    (db, playerId) => {
      db.ref(`users/${playerId}/wallets`).on('value', snapshot => {
        // listen to wallets
        let snapshotVal = snapshot.val()
        if (snapshotVal) {
          map(snapshotVal, (wallet, key) => {
            wallet.currencyId = wallet.walletName
            wallet.walletId = parseInt(key)
            return wallet
          })

          updatePlayerWallets(snapshotVal)

          if (!isPlayerActiveCurrencyDataInit.current) {
            setPlayerActiveCurrencyData(
              readZustandLocalStorage(`${playerStoreKey}.${playerStoreKeys.activeCurrencyId}`) || config.swcWalletId
            )

            isPlayerActiveCurrencyDataInit.current = true
          }

          setGameBalanceReload(true)
        }
      })
    },
    [setPlayerActiveCurrencyData, updatePlayerWallets]
  )

  return { gameBalanceReload, setGameBalanceReload, handleFirebaseWallets }
}
